import * as React from 'react'
import { ErrorBoundary } from './components/error-boundary'

export default function wrapTopLevelComponent<P = any>(
  Component: React.ComponentType<P>,
): React.ComponentType<P> {
  return (props: any) => {
    return <ErrorBoundary>
      <Component {...props}></Component>
    </ErrorBoundary>
  }
}
